import CryptoJS from 'crypto-js';

export default {
    async request(method, type, body, contentType) {
      let responce = await this.getQuery(method, type, body, contentType)
      
      if(responce.statusCode == 401 && document.location.pathname != '/login') {
        await this.getAuth()
        responce = await this.getQuery(method, type, body, contentType)
        console.log("результат запроса после повторной авторизации")
        console.log(responce)
        if(responce.statusCode == 401 && document.location.pathname != '/login') {
          document.location.href = '/login'
        }
      }

      // else if(responce.statusCode != 401 && responce.statusCode != 200) {
      //   responce = {}
      // }
  
      return responce
    },
  
    async getAuth() {
      const secretKey = "H8d50Tmz3931P0aYzga702186316TBo65";
      const encryptedData = localStorage.getItem('temp');
      // alert("получение нового токена")

      if(encryptedData != undefined && encryptedData != null) {
        const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
        const decryptedObj = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

        let options = {
          login: decryptedObj.login,
          password: decryptedObj.pass
        }
        let dataAuth = await this.getQuery("/login", "POST", options);
        if(dataAuth != undefined) {
          if (dataAuth.token) {
            let new_minut = new Date();
            new_minut.setMinutes(new_minut.getMinutes() + 30);
            document.cookie = "token=" + dataAuth.token + ";expires=" + new_minut.toUTCString()
          }
          else {
            console.log("Не удалось авторизоваться")
          }
        }
        else {
          console.log("Ошибка авторизации!")
        }
      }
      else document.location.href = '/login'
    },
  
    async getQuery(method, type, body, contentType) {
      let backURL = location.protocol + "//" + location.hostname
      
      if (process.env.NODE_ENV == "development") {
        console.log("DEVELOPMENT MODE!");
        backURL = backURL + ":8081"
      } 
      backURL = backURL + "/api"
      
      let res = document.cookie.split('; ').reduce((acc, item) => {
        const [name, value] = item.split('=')
        acc[name] = value
        return acc
      }, {})
    
      let token = res.token
  
      let query = ""
      let fetchBody = {}
      if(type == "POST") {
        if(contentType == "multipart/form-data") {
          fetchBody = {
            method: type,
            headers: {'Authorization': "Bearer " + token },
            body: body,
            redirect: 'follow'
          }
        }
        else {
          fetchBody = {
            method: type,
            headers: {'Content-Type': 'application/json', 'Authorization': "Bearer " + token },
            body: JSON.stringify(body),
            redirect: 'follow'
          }
        }
        query = fetch(backURL + method, fetchBody)
      }
      else if(type == "GET") {
        fetchBody = {
          headers: {'Authorization': "Bearer " + token }
        }
        query = fetch(backURL + method, fetchBody)
      }
      else if(type == "DELETE") {
        fetchBody = {
          method: type,
          headers: {'Authorization': "Bearer " + token }
        }
        query = fetch(backURL + method, fetchBody)
      }
  
      return query
        .then(async (response) => {
          if (!response.ok) {
            return Promise.reject({ // реджект обламывает текущий промис и передает ошибку в catch
              message: 'На запрос ' + method + ' получена ошибка со статусом ' + response.status + '. ' + response.statusText,
              statusCode: response.status,
              serviceAnswer: await response.json()
            });
          }
          return Promise.resolve(response.json())
              .then((data) => {
                // обновить куки, при выполнении запроса
                let res = document.cookie.split('; ').reduce((acc, item) => {
                  const [name, value] = item.split('=')
                  acc[name] = value
                  return acc
                }, {})
                let new_minut = new Date();
                new_minut.setMinutes(new_minut.getMinutes() + 30);
                document.cookie = "token=" + res.token + ";expires=" + new_minut.toUTCString()
  
                return data
              })
        }).catch(error => {
          console.log("Ошибка же ну")
          console.log(error)
          return error
        })
    },

    // Получение адреса
    async fetchAddressData(searchString) {
      if (!searchString) return;

      const apiKey = 'ee087720-31df-4d44-9fac-f1e88117cbdf';
      const url = 'https://fias-public-service.nalog.ru/api/spas/v2.0/SearchAddressItems';

      let query = fetch(url + "?search_string=" + searchString + "&address_type=1", {
        headers: {
          'master-token': apiKey,
        },
      })

      return query
        .then(async (response) => {
          if (!response.ok) {
            return Promise.reject({ // реджект обламывает текущий промис и передает ошибку в catch
              success: false,
              message: 'При поиске адреса произошла ошибка ' + response,
              serviceAnswer: await response.json()
            });
          }
          return Promise.resolve(response.json())
              .then((data) => {
                return {
                  success: true,
                  data: data
                }
              })
        }).catch(error => {
          return {
            success: false,
            message: 'Ошибка при получении данных адреса ' + error
          }
        })
    },

    }
  